import React from 'react';
import PropTypes from 'prop-types';
import FilterButton from '../../SharedComponents/FilterButton';
import { FILTER_VALUES, TRACKING_LABELS } from '../../constants';
import { trackEvent } from '../../../../../components/Analytics/TrackedClick';

const NowPlayingFilter = (props) => {
    const { filters, handleFilterUpdate } = props;
    const { IN_PROGRESS } = FILTER_VALUES;

    const handleClick = () => {
        handleFilterUpdate({
            dateRange: IN_PROGRESS,
            startDate: null,
            endDate: null,
            eventState: null,
        }, 'submit');

        const { NOW_PLAYING, CLIENT, EVENT_NAME } = TRACKING_LABELS;
        trackEvent(EVENT_NAME, {
            filter_name: NOW_PLAYING,
            client: CLIENT,
        });
    };

    return (
        <FilterButton
            isActive={filters.dateRange === IN_PROGRESS && !filters.eventState}
            onClick={handleClick}
        >
            Now Playing
        </FilterButton>
    );
};

NowPlayingFilter.propTypes = {
    filters: PropTypes.instanceOf(Object).isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
};

export default NowPlayingFilter;
